// extracted by mini-css-extract-plugin
module.exports = {"ContentBox":"ContentBox_ContentBox__3ExId","isOpen":"ContentBox_isOpen__3ttWh"};